import React, {Fragment} from "react";
import Button from "../Button";
import Modal from "../../layout/Modal";
import Portal from "../../layout/Portal";
import Select from "../Select";
import classNames from "classnames";
import NodeEditor from "./NodeEditor";

export default class Module extends React.Component {

    state = {
        delete: false,
        collapsed: true
    };

    render() {
        if (this.props.excluded) return <div />;
        return (
            <div className={classNames("module-holder", {disabled: this.props.disabled})}>
                {!this.props.head && this.props.partIndex === 0 && <div className="add-module">
                    <Select
                        label={false}
                        storeType="local"
                        labelKey="name"
                        valueKey="id"
                        placeholder="Új modul beszúrása"
                        disabled={this.props.disabled}
                        objectValue={false}
                        options={this.props.modules}
                        saveChanges={(field, moduleId) => {
                            this.props.onPartInsert(-1, moduleId);
                        }}
                    />
                </div>}
                <div className="module">
                    <div className="data">
                        {!this.props.fixed && this.props.drag}
                        {!this.props.disabled && !this.props.head && <Button icon={{lib: "fas", name: "hand-point-right"}} className="focus-btn" onClick={this.props.onFocusSection}/>}
                        <div className="name" onClick={() => this.setState({collapsed: !this.state.collapsed})}>{this.props.module.name}</div>
                        {!this.props.fixed && this.props.onPartRemove && <Button onClick={() => this.setState({delete: true})} icon={{lib: "fas", name: "trash"}} className="remove-btn"/>}
                    </div>
                </div>
                <div className={classNames("variables", {collapsed: this.state.collapsed})}>
                    {!!this.props.part && Object.keys(this.props.part.variables).map((variableName) => {
                        const variableData = this.props.part.variables[variableName];
                        return <NodeEditor component={this.props.component} componentId={this.props.componentId} onVariableChanged={this.props.onVariableChanged} type={variableData.type} variableName={variableName} variable={variableData.data} />
                    })}
                </div>
                {!this.props.head && <div className="add-module">
                    <Select
                        label={false}
                        storeType="local"
                        labelKey="name"
                        valueKey="id"
                        placeholder="Új modul beszúrása"
                        disabled={this.props.disabled}
                        objectValue={false}
                        options={this.props.modules}
                        saveChanges={(field, moduleId) => {
                            this.props.onPartInsert(1, moduleId);
                        }}
                    />
                </div>}
                <Portal>
                    <Modal
                        size="small"
                        header="Törlés"
                        state={this.state.delete}
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({delete: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Törlés',
                                props: {color: "danger", disabled: this.props.disabled || this.props.isLoading},
                                onClick: async () => {
                                    this.props.onPartRemove(this.props.partIndex);
                                }
                            }
                        ]}
                    >
                        Biztos törlöd?
                    </Modal>
                </Portal>
            </div>
        );
    }
}